// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"255862fa","787":"b0df9ed8","815":"aa88fd3a","849":"cd9f781b"}[chunkId] + ".chunk.js";
};